import axios from 'axios';
import { API_URL } from '../config';

export const getTopics = ({ topic }) => topic;

const reducerName = 'topic';
const createActionName = (name) => `app/${reducerName}/${name}`;
const LOAD_TOPICS = createActionName('LOAD_TOPICS');
const ADD_TOPIC = createActionName('ADD_TOPIC');
const EDIT_TOPIC = createActionName('EDIT_TOPIC');
const DELETE_TOPIC = createActionName('DELETE_TOPIC');

export const loadTopics = (payload) => ({ payload, type: LOAD_TOPICS });
export const addTopic = (payload) => ({ payload, type: ADD_TOPIC });
export const editTopic = (payload) => ({ payload, type: EDIT_TOPIC });
export const deleteTopic = (payload) => ({ payload, type: DELETE_TOPIC });

export const loadTopicsRequest = () => {
  return async (dispatch) => {
    try {
      let res = await axios.get(`${API_URL}/current-topic`, {
        withCredentials: true,
      });

      dispatch(loadTopics(res.data));
      return res;
    } catch (e) {
      console.log(e.message);
    }
  };
};

export const closeTopicRequest = (id) => {
  return async (dispatch) => {
    try {
      let res = await axios.put(
        `${API_URL}/current-topic/${id}`,
        {},
        {
          withCredentials: true,
        },
      );

      dispatch(deleteTopic(id));
      return res;
    } catch (e) {
      console.log(e.message);
    }
  };
};

export const addTopicRequest = (data) => {
  return async (dispatch) => {
    try {
      let res = await axios.post(`${API_URL}/current-topic`, data, {
        withCredentials: true,
      });
      //   dispatch(addTopic(res.data));
      return res;
    } catch (e) {
      return e.response;
    }
  };
};

const topicReducer = (statePart = [], action) => {
  switch (action.type) {
    case LOAD_TOPICS:
      return action.payload;
    case ADD_TOPIC:
      return [...statePart, action.payload];
    case EDIT_TOPIC:
      return statePart.map((topic) =>
        topic.id === action.payload.id ? action.payload : topic,
      );
    case DELETE_TOPIC:
      return statePart.filter((topic) => topic.id !== action.payload);
    default:
      return statePart;
  }
};

export default topicReducer;
